/**
 * Carousel Navigation Component
 * Handles navigation dots/buttons for carousels
 */
if (!window.customElements.get("carousel-navigation")) {
  class CarouselNavigation extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      const carouselId = this.getAttribute("aria-controls");
      if (!carouselId) return;

      this.abortController = new AbortController();
      const carousel = document.getElementById(carouselId);

      if (!carousel) {
        // Wait for carousel to be available
        setTimeout(() => this.connectedCallback(), 100);
        return;
      }

      // Listen for carousel changes
      carousel.addEventListener(
        "carousel:change",
        (event) => {
          this.onNavigationChange(event.detail.index);
        },
        { signal: this.abortController.signal }
      );

      // Setup button clicks
      const buttons = Array.from(this.querySelectorAll("button"));
      buttons.forEach((button, index) => {
        button.addEventListener(
          "click",
          () => {
            if (carousel.select) {
              carousel.select(index);
            } else if (carousel.goToSlide) {
              carousel.goToSlide(index);
            }
          },
          { signal: this.abortController.signal }
        );
      });
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    onNavigationChange(newIndex) {
      const buttons = Array.from(this.querySelectorAll("button"));
      buttons.forEach((button, index) => {
        button.setAttribute(
          "aria-current",
          newIndex === index ? "true" : "false"
        );
      });
    }
  }

  window.customElements.define("carousel-navigation", CarouselNavigation);
}

